<template>
  <div class="loading-icon" :class="{'loading-icon--expand': expand}" :style="{ '--colour1': colour1, '--colour2': colour2, '--scale': scale, 'max-height': maxHeight}">
    <div class="circle-wrapper-outer">
      <div class="circle-wrapper">
        <div class="circle1"></div>
        <div class="circle2"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingIcon',
  props: {
    colour1: {
      type: String,
      default: '#fedb00'
    },
    colour2: {
      type: String,
      default: '#fff'
    },
    size: {
      type: String,
      default: 'small'
    },
    expand: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: '100%'
    },
  },
  computed: {
    scale() {
      switch (this.size) {
        case 'tiny':
          return 0.2
        case 'small':
          return 0.4
        case 'medium':
          return 0.7
        case 'large':
          return 1
        default:
          return 0.4
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/scss/components/global/loading/loading_icon.scss';
</style>
